import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import CloseCaseButton from './CloseCaseButton';
import { store } from '../../store/store';
import { Provider } from 'react-redux';

loadDOMComponent({
	selector: 'react-close-case-button',
	callback: ({ container, context }: any) => {
		const caseId = container.getAttribute('caseId');
		const patientId = container.getAttribute('patientId');
		const type = container.getAttribute('type');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<CloseCaseButton caseId={caseId} type={type} patientId={patientId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
